import { Image, Center, AppShell } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { mainData, NavLinkItem, supportData } from 'utils/navbar';
import { PortalButton } from 'components/Button/PortalButton';
import { BsChevronLeft, BsChevronRight, BsPersonCircle, BsPlusLg } from 'react-icons/bs';
import fibricheckLogo from 'assets/logo/Fibricheck_Logo_white.svg';
import { useAppContext, useDrawerContext } from 'context/hooks';
import { showFullName } from 'utils/helpers';
import { CreatePrescription } from 'pages/Main/Patients/CreatePrescription/CreatePrescription';
import { DEFAULT_ICON_SIZE } from 'utils/general';
import { NavLink } from './NavLink';
import classes from './NavBar.module.css';

export const NavBar = () => {
  const { t } = useTranslation();
  const { currentUser, isNavBarCollapsed, setIsNavBarCollapsed } = useAppContext();
  const { openDrawer } = useDrawerContext();
  const profileData = {
    link: 'profile',
    label: showFullName(currentUser?.user),
    leftIcon: <BsPersonCircle size={DEFAULT_ICON_SIZE} />,
  };

  const renderLinks = (data: NavLinkItem[], small?: boolean) => {
    return data.map((item: NavLinkItem, index: number) => {
      if (item.hideOnNavbar) return null;
      return <NavLink key={index} item={item} testId={item.label.toLowerCase()} small={small} />;
    });
  };

  return (
    <>
      <AppShell.Section grow>
        <Center pb={'lg'}>
          <Image src={fibricheckLogo} w={70} data-testid={'nav-image-fibricheck'} />
        </Center>
        <PortalButton
          Icon={BsPlusLg}
          fullWidth
          color={'var(--mantine-color-turquoise-5)'}
          label={!isNavBarCollapsed ? t('navbar_create_prescription') : undefined}
          onClick={() =>
            openDrawer({
              content: <CreatePrescription />,
              size: '80%',
              title: t('navbar_create_prescription'),
            })
          }
          tooltip={isNavBarCollapsed ? { label: t('navbar_create_prescription'), position: 'right' } : undefined}
          testId={'nav-button-create-prescription'}
        />
        {renderLinks(mainData)}
        {renderLinks(supportData, true)}
      </AppShell.Section>
      <AppShell.Section>
        <hr />
        <NavLink item={profileData} testId={'user'} />
      </AppShell.Section>
      <Center className={classes.expandButton} onClick={() => setIsNavBarCollapsed(!isNavBarCollapsed)}>
        {isNavBarCollapsed && <BsChevronRight color={'var(--mantine-color-turquoise-3)'} />}
        {!isNavBarCollapsed && <BsChevronLeft color={'var(--mantine-color-turquoise-3)'} />}
      </Center>
    </>
  );
};
